import {
  logTopicViewed,
  logTopicAboutViewed,
  logTopicUpdatesViewed,
  logTopicAlgorithmsViewed,
  logTopicChecklistViewed,
  logTopicImageGalleryViewed,
  logTopicVideoGalleryViewed,
  logTopicInDepthAnswersViewed,
  logTopicTablesGalleryViewed,
} from "./analytics";

import { tabTypes } from "../constants/tab-types";

export const handleTabView = (tabType, payload) => {
  switch (tabType) {
    case tabTypes.IMAGES:
      logTopicImageGalleryViewed(payload);
      break;
    case tabTypes.VIDEOS:
      logTopicVideoGalleryViewed(payload);
      break;
    case tabTypes.ALERTS:
      logTopicUpdatesViewed(payload);
      break;
    case tabTypes.CHECKLIST:
      logTopicChecklistViewed(payload);
      break;
    case tabTypes.ALGORITHMS:
      logTopicAlgorithmsViewed(payload);
      break;
    case tabTypes.ABOUT:
      logTopicAboutViewed(payload);
      break;
    case tabTypes.DETAILS:
      logTopicInDepthAnswersViewed(payload);
      break;
    case tabTypes.TABLES:
      logTopicTablesGalleryViewed(payload);
      break;
    case undefined:
      logTopicViewed(payload);
      break;
    default:
      break;
  }
};
